import { generatePath } from "react-router-dom";
import { BenefitsInsuranceTab } from "./routes/RouteBenefitsInsurance/contsants";
import { IPlanType } from "../../services/api/planEnrollment/types";

export const PATH_BENEFITS = "/member/benefits";

export const PATH_BENEFITS_INSURANCE = PATH_BENEFITS + "/insurance";

export const PATH_BENEFITS_PERKS = PATH_BENEFITS + "/my-benefits";

export const PATH_BENEFITS_PERKS_PREVIEW = PATH_BENEFITS_PERKS + "/dashboard";

export const PATH_BENEFITS_ENROLL = PATH_BENEFITS + "/enroll";

export const PATH_BENEFITS_TAB = `${PATH_BENEFITS_INSURANCE}/:tab`;

export const PATH_BENEFITS_INSURANCE_DETAILS = `${PATH_BENEFITS_TAB}/:benefit`;

export const PATH_BENEFITS_INSURANCE_ENROLL =
  PATH_BENEFITS + "/insurance-enroll";

export const PATH_BENEFITS_INSURANCE_ENROLL_FLOW =
  PATH_BENEFITS_INSURANCE_ENROLL + "/:slug";

export const getBenefitsEnrollInsuranceFlowPathname = (slug: IPlanType) => {
  return generatePath(PATH_BENEFITS_INSURANCE_ENROLL_FLOW, {
    slug
  });
};

export const getBenefitsInsuranceDetailsPathname = (
  tab: BenefitsInsuranceTab,
  benefit: IPlanType | string
) => {
  return generatePath(PATH_BENEFITS_INSURANCE_DETAILS, {
    tab,
    benefit
  });
};

export const getBenefitsTabPathname = (tab: BenefitsInsuranceTab) => {
  return generatePath(PATH_BENEFITS_TAB, {
    tab
  });
};
